import React, { useState, useEffect } from "react";
import { doc, setDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../../../firebase";
import {
  TextField,
  Button,
  Grid,
  Container,
  Typography,
  Card,
  CardContent,
  Snackbar,
  Alert,
} from "@mui/material";
import { v4 as uuidv4 } from "uuid";

const SendNotification = () => {
  const [category, setCategory] = useState({
    message: "",
    id: "",
    title: "",
  });

  const [openSnackbar, setOpenSnackbar] = useState(false);

  useEffect(() => {
    // Generate a new uuid when the component mounts
    setCategory((prevCategory) => ({
      ...prevCategory,
      id: uuidv4(),
    }));
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCategory((prevCategory) => ({
      ...prevCategory,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const uniqueId = category.id; // Use the id already set in the state

    const categoryData = {
      ...category,
      timestamp: serverTimestamp(),
    };

    try {
      await setDoc(doc(db, "notification", uniqueId), categoryData);
      setOpenSnackbar(true);
      setCategory({
        message: "",
        id: uuidv4(), // Generate a new uuid for the next category
        title: "",
      });
    } catch (error) {
      console.error("Error adding category: ", error);
      alert("Error adding category");
    }
  };

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  return (
    <Container
      maxWidth="sm"
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
      }}
    >
      <Card>
        <CardContent>
          <Typography variant="h4" component="h1" gutterBottom>
            Send Notification
          </Typography>
          <form onSubmit={handleSubmit}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Title"
                  name="title"
                  value={category.title}
                  onChange={handleChange}
                  required
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="ID"
                  name="id"
                  value={category.id}
                  onChange={handleChange}
                  required
                  disabled // ID field is disabled to prevent editing
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Message"
                  name="message"
                  multiline
                  value={category.message}
                  onChange={handleChange}
                  required
                />
              </Grid>
             
              <Grid item xs={12}>
                <Button
                  variant="contained"
                  color="primary"
                  type="submit"
                  fullWidth
                >
                  Send Notification
                </Button>
              </Grid>
            </Grid>
          </form>
        </CardContent>
      </Card>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity="success"
          sx={{ width: "100%" }}
        >
          send notification successfully!
        </Alert>
      </Snackbar>
    </Container>
  );
};

export default SendNotification;
